import React from 'react';
import PageTransition from '@/components/page-transition/PageTransition';
import classes from './strategy.module.scss';
import Text from '@/components/text/text';
import Hero from '@/components/hero/hero';
import StructuredData from './structured-data';
import Contact from '@/components/contact/contact';
import ContentArea from '@/components/content-area/content-area';
import SplitContent from '@/components/split_content/split_content';
import Link from 'next/link';
import StrategyLogo from '@/components/icons/strategy';

export default function Strategy() {

  return (
    <>
      <StructuredData />
      <PageTransition>
        <main className={classes.wrapper}>
          <div className={'body-bg'}></div>
          <Hero
            title='Sports Digital Marketing Strategy'
            text="small"
          />
          <ContentArea hero>
            <>
              <StrategyLogo isActive duration={1} isPrevActive={false} feature />
              <SplitContent>
                <>
                  <Text type={'h5'} column={0}>In the ever-changing world of digital marketing, a strong digital strategy is your playbook for success. </Text>
                  <Text type={'p'} column={0}>At eighteen yards, we are committed to empowering your approach towards digital and propelling you towards your goals. Our Strategy services will provide you with a competitive edge across your digital channels.</Text>

                </>
              </SplitContent>
            </>
          </ContentArea>
          <ContentArea>
            <>
              <Text type={'h2'} column={0} size='medium'>Digital Strategy</Text>
              <SplitContent>
                <>
                  <div>
                    <Text type={'p'} column={0}>We craft customised digital strategies tailored to your unique needs and objectives. Our approach is to combine industry expertise, data-driven insights, and innovative technology to deliver solutions that align precisely with your business needs.</Text>
                  </div>
                  <div>
                    <Text type={'p'} column={0}>Our Digital Strategy services are anchored in data and analytics. We leave nothing to guesswork. Through meticulous analysis of your digital footprint, performance of current marketing efforts, and thorough competitor research, we gather the insights needed to create a robust strategy.</Text>
                  </div>
                </>
              </SplitContent>
            </>
          </ContentArea>
          <ContentArea>
            <>
              <Text type={'h2'} column={0} size='medium'>Performance Marketing Strategy</Text>
              <SplitContent>
                <>
                  <div>
                    <Text type={'p'} column={0}>Our Performance Marketing Strategies are all about maximising your return on investment. Our solutions incorporate search engine optimisation (SEO), paid social media advertising and paid search advertising, all working together to enhance your brand&rsquo;s visibility, impact, and ability to drive conversions.</Text>
                  </div>
                  <div>
                    <Text type={'p'} column={0}>We don&rsquo;t just focus on driving traffic, but on converting that traffic into tangible results, whether it&rsquo;s sales, sign-ups, or any other action aligned with your goals.</Text>
                  </div>
                </>
              </SplitContent>
            </>
          </ContentArea>
          <ContentArea>
            <>
              <Text type={'h2'} column={0} size='medium'>Take Your Game to the Next Level</Text>
              <SplitContent>
                <>
                  <Text type={'p'} column={0}>If you have any questions or would like to discuss how our strategy services can benefit your sports business, don&rsquo;t hesitate to <Link href="/contact">contact</Link> our team of sports marketing experts.
                    At eighteen yards, we&rsquo;re passionate about sports digital marketing, and we&rsquo;re dedicated to helping you succeed. Join us, and let&rsquo;s outscore your opponents together.
                  </Text>
                </>
              </SplitContent>
            </>
          </ContentArea>

          <Contact />


        </main>
      </PageTransition>
    </>
  )
}
